import { usePintMaster, createControlFieldServices, createControlFieldServicesc2c } from '@lib/common';
import { TextField } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import { Autocomplete } from '@material-ui/lab';
import styled from 'styled-components';
import * as ContentGenres from '@api/content-genres';
import { useRequest } from '@lib/common';
import React, { useEffect, useState } from 'react';
import { map } from 'rxjs/operators';

const AutoCompleteServices = ({ value, onChange, setAssociatedServices=null, services=null, selected_services=[], setServices=null,...props}) => {


  return (
    <GenreStypes>
      <Autocomplete
        multiple
        size="small"
        fullWidth
        freeSolo={true}
        filterSelectedOptions
        // onInputChange={(evt, v) => onChange && onChange(v)}
        // value={value || []}
        // value={ageOptions.find(v => v.label === age[0]) || {}}
        defaultValue={selected_services || []}
        // defaultValue={(selected_services !=null && selected_services?.length > 0) ? selected_services : value}
        onChange={(evt, v) => {onChange && onChange(v), setServices(v)}}
        options={!services ? [{label:"Loading...", id:0}] : services?.media_and_services }
        // options={[{'id': 31, 'is_deleted': false, 'name': 'Production', 'order_id': 3}, {'id': 32, 'is_deleted': false, 'name': 'Distribution', 'order_id': 1}]}
        getOptionLabel={ (option)=>option['name'] }
        
        renderInput={props => (
          <TextField
            helperText="Select all the services relevant to this media."
            label={'Services'}
            placeholder={'Services'}
            fullWidth
            variant="outlined"
            {...props}
          />
        )}
      />
      {/* <Autocomplete
        multiple
        size="small"
        fullWidth
        freeSolo={true}
        filterSelectedOptions
        // onInputChange={(evt, v) => onChange && onChange(v)}
        value={value || []}
        // value={ageOptions.find(v => v.label === age[0]) || {}}
        defaultValue={[{'id': 31, 'name': 'Production'}]}
        // defaultValue={(selected_services !=null && selected_services?.length > 0) ? selected_services : value}
        onChange={(evt, v) => {onChange && onChange(v), setServices(v)}}
       
        options={!services ? [{label:"Loading...", id:0}] : services?.media_and_services }
        getOptionLabel={(value)=> ((value && value?.name) ? value?.name : null)}
        
        renderInput={props => (
          <TextField
            helperText="Select all the services relevant to this media."
            label={'Services'}
            placeholder={'Services'}
            fullWidth
            variant="outlined"
            {...props}
          />
        )}
      /> */}
    </GenreStypes>
  );
};

const GenreStypes = styled.div`
  .MuiChip-root {
    background: ${blue[600]};
    color: white;
  }
  .MuiChip-deleteIcon {
    color: white;
  }
`;

// export const ServicesField = createControlFieldServices(props => (
//     <AutoCompleteServices {...props} />
//   ));
export const ServicesField = createControlFieldServicesc2c(AutoCompleteServices, []);
